import { Sync, registerSync } from 'olympe';

/**
 * @extends {Sync}
 */
export class MapboxMarker extends Sync {

    getItem() {
        const itemTag = this.db.getUniqueRelated(this, MapboxMarker.itemRel);
        return itemTag ? Sync.getInstance(itemTag) : null;
    }

}

// Hardcoded tags
MapboxMarker.entry = registerSync('017c4b2a8882e9b71955', MapboxMarker);
MapboxMarker.latitudeProp = MapboxMarker.entry.addProperty('017c4b2acb28ff42dd02');
MapboxMarker.longitudeProp = MapboxMarker.entry.addProperty('017c4b2ae08e182f544d');
MapboxMarker.colorProp = MapboxMarker.entry.addProperty('017c4b2b0582a96d85b3');
MapboxMarker.iconProp = MapboxMarker.entry.addProperty('017c4b51e759520b939d');
MapboxMarker.rotationProp = MapboxMarker.entry.addProperty('017c4b526474d4d361b9');
MapboxMarker.iconSizeProp = MapboxMarker.entry.addProperty('017c4b53209b63b9c0b9');
MapboxMarker.popupTextProp = MapboxMarker.entry.addProperty('017c4b52cb8de79f7825');
MapboxMarker.itemRel = MapboxMarker.entry.addRelation('017c4b550d94e9147da2');

